import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./TolovKontrakt.module.css";
import axios from "axios";
import { testUrl } from "../../home/BaseData";

// Static data for contract prices
const staticContractData = {
  bachelorCourses: [
    { id: 1, title_uz: "Boshlang'ich ta'lim", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 2, title_uz: "Maktabgacha ta'lim", daytime_price: 16000000, evening_price: 14000000, day_duration: "3", evening_duration: "4.5" },
    { id: 3, title_uz: "Tarix", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 4, title_uz: "Milliy g'oya, ma'naviyat asoslari va huquq ta'limi", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 5, title_uz: "Psixologiya", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 6, title_uz: "Falsafa", daytime_price: 11000000, evening_price: 10000000, day_duration: "4", evening_duration: "4.5" },
    { id: 7, title_uz: "Xorijiy til va adabiyoti (ingliz tili)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 8, title_uz: "Filologiya va tillarni o'qitish (ingliz tili)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 9, title_uz: "Filologiya va tillarni o'qitish (rus tili)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 10, title_uz: "Filologiya va tillarni o'qitish (o'zbek tili)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 11, title_uz: "Iqtisodiyot", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 12, title_uz: "Jahon iqtisodiyoti va xalqaro iqtisodiy munosabatlar", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 13, title_uz: "Xalqaro munosabatlar", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 14, title_uz: "Moliya va moliyaviy texnologiyalar", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 15, title_uz: "Bank ishi", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 16, title_uz: "Menejment", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 17, title_uz: "Buxgalteriya hisobi", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 18, title_uz: "Soliqlar va soliqqa tortish", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 19, title_uz: "Inson resurslarini boshqarish", daytime_price: 11000000, evening_price: 10000000, day_duration: "4", evening_duration: "4.5" },
    { id: 20, title_uz: "Axborot tizimlari va texnologiyalari", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 21, title_uz: "Sun'iy intellekt", daytime_price: 11000000, evening_price: 10000000, day_duration: "4", evening_duration: "4.5" },
    { id: 22, title_uz: "Pedagogika", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 23, title_uz: "Filologiya va tillarni o'qitish (Xitoy tili)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 24, title_uz: "Filologiya va tillarni o'qitish (Koreys tili)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 25, title_uz: "Matematika", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 26, title_uz: "Mehnat muhofazasi va texnika xavfsizligi", daytime_price: 16000000, evening_price: 0, day_duration: "4", evening_duration: "4.5" },
    { id: 27, title_uz: "Amaliy matematika", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 28, title_uz: "Geodeziya va geoinformatika", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 29, title_uz: "Turizm va mehmondo'stlik", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 30, title_uz: "Dizayn (libos va gazlamalar)", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 31, title_uz: "Dizayn (interyer dizayni)", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 32, title_uz: "Kompyuter injiniringi", daytime_price: 17000000, evening_price: 15000000, day_duration: "4", evening_duration: "4.5" },
    { id: 33, title_uz: "Sport faoliyati (Basketbol)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 34, title_uz: "Sport faoliyati (Voleybol)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 35, title_uz: "Sport faoliyati (Futbol)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 36, title_uz: "Sport faoliyati (Belbog'li kurash)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 37, title_uz: "Sport faoliyati (Kurash)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 38, title_uz: "Sport faoliyati (Boks)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 39, title_uz: "Sport faoliyati (Taekvondo WТF)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 40, title_uz: "Sport faoliyati (Yengil atletika)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 41, title_uz: "Sport faoliyati (Badiiy gimnastika)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 42, title_uz: "Sport faoliyati (Erkin kurash)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 43, title_uz: "Sport faoliyati (Gandbol)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 44, title_uz: "Sport faoliyati (Dzyu-do)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" },
    { id: 45, title_uz: "Sport faoliyati (Stol tennis)", daytime_price: 16000000, evening_price: 14000000, day_duration: "4", evening_duration: "4.5" }
  ],
  masterCourses: [
    { id: 1, title_uz: "Iqtisodiyot", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 2, title_uz: "Buxgalteriya hisobi", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 3, title_uz: "Sport faoliyati", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 4, title_uz: "Lingvistika (Ingliz tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 5, title_uz: "Lingvistika (Rus tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 6, title_uz: "Lingvistika (O'zbek tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 7, title_uz: "Lingvistika (Qoraqalpoq tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 8, title_uz: "Lingvistika (Turkman tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 9, title_uz: "Lingvistika (Tojik tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 10, title_uz: "Lingvistika (Sharq tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" },
    { id: 11, title_uz: "Lingvistika (Qozoq tili)", daytime_price: 19000000, evening_price: 0, day_duration: "2", evening_duration: "2" }
  ]
};

// Helper functions moved outside component to prevent recreation on every render
const getTitle = (item, language) => item?.[`name_${language}`] || item?.name_uz || "";
const getCourseTitle = (item, language) => item?.[`title_${language}`] || item?.title_uz || "";

const TolovKontrakt = () => {
  const { i18n } = useTranslation();

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [useStaticData, setUseStaticData] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${testUrl}/api/fields/categories/`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setCategories(res.data);
          setUseStaticData(false);
        } else {
          setUseStaticData(true);
        }
      })
      .catch(() => {
        setUseStaticData(true);
      })
      .finally(() => setLoading(false));
  }, [i18n.language]);

  const formatMoney = (value) => {
    if (value === null || value === undefined || value === 0) return "-";
    try {
      const num = Number(value);
      return `${num.toLocaleString("uz-UZ")} so'm`;
    } catch {
      return `${value}`;
    }
  };

  const { bachelorCourses, masterCourses } = useMemo(() => {
    if (useStaticData) {
      return {
        bachelorCourses: staticContractData.bachelorCourses,
        masterCourses: staticContractData.masterCourses,
      };
    }

    const match = (name, key) => (name || "").toLowerCase().includes(key);
    const bachelorCat = categories.find((c) => match(getTitle(c, i18n.language), "baka"));
    const masterCat = categories.find((c) => match(getTitle(c, i18n.language), "magis"));
    return {
      bachelorCourses: bachelorCat?.courses || [],
      masterCourses: masterCat?.courses || [],
    };
  }, [categories, i18n.language, useStaticData]);

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <div className={classes.content}>
          <h1 className={classes.title}>To'lov kontrakt miqdori</h1>
          <p className={classes.subtitle}>Qabul - To'lov kontrakt miqdori</p>
          
          <div className={classes.section}>
            <div className={classes.universityInfo}>
              <p className={classes.description}>
                Renessans Universiteti Davlat ta'lim sifatini nazorat qilish inspeksiyasi huzuridagi Vazirlar Mahkamasi tomonidan 18.11.2022 yil № 049194 raqam bilan berilgan davlat litsenziyasi asosida tashkil etilgan bo'lib, to'liq kunlik, sirtqi va kechki ta'lim shakllarida, shuningdek, ikkinchi mutaxassislik bo'yicha o'zbek, rus va ingliz tillarida yuqori malakali bakalavrlar tayyorlaydi.
              </p>
              <p className={classes.description}>
                O'quv faoliyati mahalliy va xorijiy mamlakatlardagi nufuzli oliy o'quv yurtlarini tugatgan xalqaro va mahalliy professorlar tomonidan amalga oshiriladi.
              </p>
              <p className={classes.description}>
                Universitetning vazifasi - jamiyat va iqtisodiyotning zamonaviy rivojlanish muammolariga samarali javob bera oladigan, mamlakat va xorijda tan olingan ilmiy-ta'lim markaziga aylanish imkoniyatiga ega bo'lgan yuqori malakali mutaxassislar tayyorlashdir.
              </p>
            </div>

            {loading ? (
              <div>Yuklanmoqda...</div>
            ) : (
              <>
            <div className={classes.programsSection}>
              <h2 className={classes.sectionTitle}>Bakalavriat</h2>
              
              <div className={classes.tableContainer}>
                <table className={classes.feesTable}>
                  <thead>
                    <tr>
                      <th>№</th>
                      <th>Yo'nalish nomi</th>
                      <th>Kunduzgi narx</th>
                      <th>Kechki narx</th>
                      <th>O'qish muddati kunduzgi</th>
                      <th>O'qish muddati kechki</th>
                    </tr>
                  </thead>
                  <tbody>
                        {(bachelorCourses || []).map((c, idx) => (
                          <tr key={c.id || idx}>
                            <td>{idx + 1}</td>
                            <td className={classes.programName}>{getCourseTitle(c, i18n.language)}</td>
                            <td>{formatMoney(c.daytime_price)}</td>
                            <td>{formatMoney(c.evening_price)}</td>
                            <td>{c.day_duration || '-'} yil</td>
                            <td>{c.evening_duration || '-'} yil</td>
                      </tr>
                    ))}
                        {bachelorCourses?.length === 0 && (
                          <tr>
                            <td colSpan={6}>Ma'lumotlar topilmadi</td>
                          </tr>
                        )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className={classes.programsSection}>
              <h2 className={classes.sectionTitle}>Magistratura</h2>
              
              <div className={classes.tableContainer}>
                <table className={classes.feesTable}>
                  <thead>
                    <tr>
                      <th>№</th>
                      <th>Yo'nalish nomi</th>
                      <th>Kunduzgi narx</th>
                      <th>Kechki narx</th>
                      <th>O'qish muddati kunduzgi</th>
                      <th>O'qish muddati kechki</th>
                    </tr>
                  </thead>
                  <tbody>
                        {(masterCourses || []).map((c, idx) => (
                          <tr key={c.id || idx}>
                            <td>{idx + 1}</td>
                            <td className={classes.programName}>{getCourseTitle(c, i18n.language)}</td>
                            <td>{formatMoney(c.daytime_price)}</td>
                            <td>{formatMoney(c.evening_price)}</td>
                            <td>{c.day_duration || '-'} yil</td>
                            <td>{c.evening_duration || '-'} yil</td>
                      </tr>
                    ))}
                        {masterCourses?.length === 0 && (
                          <tr>
                            <td colSpan={6}>Ma'lumotlar topilmadi</td>
                          </tr>
                        )}
                  </tbody>
                </table>
              </div>
            </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TolovKontrakt; 